const PREFIX = "resto_store_cart_";

/** @typedef {{ menu_item_id: number, product_id?: number, name: string, qty: number, unit_price: number }} CartLine */

/** @returns {CartLine[]} */
export function getCart(branchCode) {
  if (!branchCode) return [];
  try {
    const raw = localStorage.getItem(`${PREFIX}${branchCode}`);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

/** @param {CartLine[]} lines */
export function setCart(branchCode, lines) {
  if (!branchCode) return;
  localStorage.setItem(`${PREFIX}${branchCode}`, JSON.stringify(lines));
}

export function addToCart(branchCode, line) {
  const cart = getCart(branchCode);
  const idx = cart.findIndex((l) => l.menu_item_id === line.menu_item_id);
  if (idx >= 0) {
    cart[idx] = { ...cart[idx], qty: cart[idx].qty + line.qty };
  } else {
    cart.push({ ...line, product_id: line.menu_item_id });
  }
  setCart(branchCode, cart);
  return cart;
}

export function updateCartQty(branchCode, index, qty) {
  const cart = getCart(branchCode);
  if (qty <= 0) cart.splice(index, 1);
  else cart[index] = { ...cart[index], qty };
  setCart(branchCode, cart);
  return cart;
}

export function clearCart(branchCode) {
  if (!branchCode) return;
  localStorage.removeItem(`${PREFIX}${branchCode}`);
}

export function cartSubtotal(lines) {
  return lines.reduce((s, l) => s + (Number(l.unit_price) || 0) * (Number(l.qty) || 0), 0);
}

export function storeTrackingSearch(searchParams) {
  const p = new URLSearchParams();
  ["source", "campaign", "qr_token"].forEach((k) => {
    const v = searchParams.get(k);
    if (v) p.set(k, v);
  });
  const s = p.toString();
  return s ? `?${s}` : "";
}

export function storeTrackingPayload(searchParams) {
  return {
    source: searchParams.get("source") || undefined,
    campaign: searchParams.get("campaign") || undefined,
    qr_token: searchParams.get("qr_token") || undefined,
  };
}
